import { render } from "./insuCompanyAdmin.vue?vue&type=template&id=0869b3da&scoped=true"
import script from "./insuCompanyAdmin.vue?vue&type=script&lang=js"
export * from "./insuCompanyAdmin.vue?vue&type=script&lang=js"

import "./insuCompanyAdmin.vue?vue&type=style&index=0&id=0869b3da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0869b3da"]])

export default __exports__